var lotApp = angular.module('lot', [
    'commons.app',
    'uuid4',
    'angular-md5'
]);